/* Partes comuns de "Monte seu gráfico" e "Meus gráficos". */

import type { Params } from '../../core/api';
import { cat } from '../../core/estado';
import type { ConfigGrafico } from '../../tipos/api';
import { paramsFiltro } from '../../ui/filtros';

export const CONFIG_PADRAO: ConfigGrafico = {
  metrica: 'total', dimensao: 'obra', dimensao2: 'escopo', tipo: 'barras', limite: 12, filtros: {},
};

/** Parâmetros de GET /agregado: ano e obra dos filtros da tela + a configuração do gráfico. */
export function paramsDoGrafico(c: ConfigGrafico): Params {
  return {
    ...paramsFiltro({ escopo: undefined }),
    metrica: c.metrica, dimensao: c.dimensao, dimensao2: c.dimensao2 || undefined, tipo: c.tipo, limite: c.limite,
    escopo: c.filtros.escopo || undefined, categoria: c.filtros.categoria || undefined,
  };
}

const nomeDe = (lista: { id: string; nome: string }[], id: string | null) => lista.find((x) => x.id === id)?.nome || id || '';

/** Ex.: "Emissões totais por obra e escopo — escopo 3". */
export function tituloAutomatico(c: ConfigGrafico): string {
  const o = cat().graficos;
  const partes = [`${nomeDe(o.metricas, c.metrica)} por ${nomeDe(o.dimensoes, c.dimensao).toLowerCase()}`];
  if (c.dimensao2) partes[0] += ` e ${nomeDe(o.dimensoes, c.dimensao2).toLowerCase()}`;
  if (c.filtros.escopo) partes.push(`escopo ${c.filtros.escopo}`);
  return partes.join(' — ');
}

/** Sugestões prontas: preenchem o construtor com um clique. */
export const SUGESTOES: { nome: string; config: ConfigGrafico }[] = [
  { nome: 'Obras por escopo', config: { ...CONFIG_PADRAO } },
  { nome: 'Evolução mensal por escopo', config: { ...CONFIG_PADRAO, dimensao: 'mes', dimensao2: 'escopo', tipo: 'linhas' } },
  { nome: 'Materiais que mais emitem', config: { ...CONFIG_PADRAO, dimensao: 'material', dimensao2: null, tipo: 'pizza' } },
  { nome: 'Categorias por mês', config: { ...CONFIG_PADRAO, dimensao: 'mes', dimensao2: 'categoria_geral', tipo: 'barras' } },
  { nome: 'Fornecedores do escopo 3', config: { ...CONFIG_PADRAO, dimensao: 'fornecedor', dimensao2: null, tipo: 'barras_horizontais', limite: 8, filtros: { escopo: '3' } } },
  { nome: 'Lançamentos por obra', config: { ...CONFIG_PADRAO, metrica: 'lancamentos', dimensao2: null, tipo: 'tabela' } },
];
